/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import { createStore } from 'vuex';
// Global
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Module
import dbOption from './moduleDbOption'
import context from './context/moduleContext';
import createPersistedState from 'vuex-persistedstate';
import register from './modules/register.module';
import session from './session/moduleSession';
import globalcontext from './globalcontext/moduleGlobalContext';

///license
import dialog from  './modules/dialog.module'
import loading from './modules/loading.module'
import popup from './modules/popup.module'
import tickets  from './modules/tickets.module'
import refresh from './modules/refresh.module'

const KEY_SESSION = "LICENSE-KEY-SESSION";
const KEY_LOCALSTORAGE ="LICENSE-KEY-STORAGE";
const KEY_LOCALSTORAGE_GL = 'LICENSE-KEY-STORAGE-GL';

// Init instance of store
export default createStore({
  getters,
  mutations,
  state,
  actions,
  modules: {
    context,
    dbOption,
    dialog,
    loading,
    register,
    popup,
    tickets,
    refresh,
    session,
    globalcontext,
  },
  strict: false,
  plugins: [
    createPersistedState({
      key: KEY_LOCALSTORAGE,
      storage: window.localStorage,
      paths: ['context'],
      getState: (key) => {
        let temp = localStorage.getItem(key);
        if (temp && typeof temp === 'string') {
          let state = JSON.parse(temp);
          if (state) {
            let context = state.context;
            if (context && context.Token) {
              context.Context = context.Context || {};
              try {
                context.TokenExpired = new Date(context.TokenExpired);

                if (context.PostedDate) {
                  context.PostedDate = new Date(context.PostedDate);
                } else {
                  let now = new Date();
                  context.PostedDate = new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    now.getDate()
                  );
                }
              } catch (ex) {
                console.error(ex);
              }
            }
          }

          return state;
        }
        return null;
      },
      setState: (key, state) => {
        localStorage.setItem(key, JSON.stringify(state));
      },
    }),
    createPersistedState({
      key: KEY_LOCALSTORAGE_GL,
      paths: ['globalcontext'],
      storage: window.localStorage,
      getState: (key) => {
        let temp = localStorage.getItem(key);
        if (temp && typeof temp === 'string') {
          let state = JSON.parse(temp);
          return state;
        }
        return null;
      },
      setState: (key, state) => {
        localStorage.setItem(key, JSON.stringify(state));
      },
    }),
    createPersistedState({
      key: KEY_SESSION,
      paths: ['session'],
      storage: window.sessionStorage,
      getState: (key) => {
        let temp = window.sessionStorage.getItem(key);
        if (temp && typeof temp === 'string') {
          let state = JSON.parse(temp);
          return state;
        }
        return null;
      },
      setState: (key, state) => {
        window.sessionStorage.setItem(key, JSON.stringify(state));
      },
      removeState: (key) => sessionStorage.removeItem(key),
    }),
  ],
});
